export const HEADING_OPTIONS = [
    {
        label: "Normal",
        value:"",
    },
    {
        label: "Heading 1",
        value: "1",
    },
    {
        label: "Heading 2",
        value: "2",
    },
    {
        label: "Heading 3",
        value: "3",
    },
    {
        label: "Heading 4",
        value: "4",
    },
    {
        label: "Heading 5",
        value: "5",
    },
    {
        label: "Heading 6",
        value: "6",
    },
]

export  const truncateWithEllipsis = (html, max = 200) => {
  const div = document.createElement("div");
  div.innerHTML = html;

  let count = 0, done = false;

  const walk = (node) => {
    if (done) return null;

    if (node.nodeType === 3) { // Text node
      const text = node.textContent;
      if (count + text.length <= max) {
        count += text.length;
        return document.createTextNode(text);
      } else {
        const slice = text.slice(0, max - count).trim();
        done = true;
        return document.createTextNode(slice + ' ');
      }
    }

    if (node.nodeType === 1) { // Element node
      const el = node.cloneNode(false);
      node.childNodes.forEach(child => {
        const part = walk(child);
        if (part) el.appendChild(part);
      });
      return el;
    }

    return null;
  };

  const truncated = walk(div);

  if (truncated && done) {
    const dots = document.createElement("span");
    dots.style.color = "#123FBC";
    dots.style.fontSize = "16px";
    dots.style.fontWeight = "bold";
    dots.textContent = "...";

    let last = truncated;
    while (last.lastChild) last = last.lastChild;
    last.parentNode.appendChild(dots);
  }

  const wrapper = document.createElement("div");
  wrapper.appendChild(truncated);
  return wrapper.innerHTML;
};

export const isEmptyHTML = (html) => {
  const temp = document.createElement('div');
  temp.innerHTML = html;
  const text = temp.textContent?.replace(/\u00A0/g, ' ').trim(); // replaces &nbsp; with space
  const hasMeaningfulContent = text && text.length > 0;
  return !hasMeaningfulContent;
};
